declare global {
  interface Window {
    __performanceObserver__?: PerformanceObserver | null;
  }
}

interface AlpineDataStack {
  showAfter: (type: string, delay: number) => void;
  hide: (type: string) => void;
}

interface AlpineElement extends HTMLElement {
  _x_dataStack?: AlpineDataStack[];
}

export function setupPerformanceObserver() {
  if (!("PerformanceObserver" in window)) return;

  if (window.__performanceObserver__) {
    console.log("PerformanceObserver already initialized");
    return;
  }

  let feedbackTimer: ReturnType<typeof setTimeout> | null = null;
  const FEEDBACK_DELAY = 2000;
  const LONG_TASK_THRESHOLD = 250;
  const DEBOUNCE_DELAY = 300;

  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) {
      if (entry.duration > LONG_TASK_THRESHOLD) {
        // Display the feedback with debounce delay to avoid blinking issues
        const el = document.querySelector<AlpineElement>("#js-feedback");
        if (el?._x_dataStack?.[0]) {
          el._x_dataStack[0].showAfter("js", DEBOUNCE_DELAY);
        }

        // Reset timer and hide feedback after delay
        if (feedbackTimer) clearTimeout(feedbackTimer);

        feedbackTimer = setTimeout(() => {
          if (el?._x_dataStack?.[0]) {
            el._x_dataStack[0].hide("js");
          }
        }, FEEDBACK_DELAY);
      }
    }
  });

  observer.observe({ entryTypes: ["longtask"] });

  window.addEventListener("beforeunload", () => {
    observer.disconnect();
    window.__performanceObserver__ = null;
  });
}
